<template>
  <div id="app"><RouterView /></div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}

html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
}

* {
  -webkit-overflow-scrolling: touch;
  outline: none;
  box-sizing: border-box;
  font-family: PT Sans, Helvetica, Arial, sans-serif;
}

[draggable] {
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  /* Required to make elements draggable in old WebKit */
  -khtml-user-drag: element;
  -webkit-user-drag: element;
}
</style>
